import { render, staticRenderFns } from "./complaintManage.vue?vue&type=template&id=94bedb00&scoped=true"
import script from "./complaintManage.vue?vue&type=script&lang=js"
export * from "./complaintManage.vue?vue&type=script&lang=js"
import style0 from "./complaintManage.vue?vue&type=style&index=0&id=94bedb00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bedb00",
  null
  
)

export default component.exports